import { format } from "date-fns";

import {
  createSlice,
  createAsyncThunk,
} from '@reduxjs/toolkit'


const initialState = {
  reportData: {
    status: "idle",
    data: [],
    error: {},
  },
}

export const fetchAll = createAsyncThunk('all_report', async (data) => {
    const {token} = data
       const axios = require("axios")
       const headers = {
                 "Authorization" : `Bearer ${token}`,
                 "Access-Control-Allow-Origin" : "*",
                 "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
              }
      const url = `/api/v0/data/harvest_report/YILI/all` 

       const response = await axios.get(url, 
                 { headers })
      return response.data
})

const harvestAllReportSlice = createSlice({
  name: 'all_report',
  initialState: initialState,
  reducers: {},
  extraReducers: {
    [fetchAll.pending.type]:(state, action) => {
      state.reportData = {
        status: "loading",
        data: [],
        error: {},
      }
    },
    [fetchAll.fulfilled.type]:(state, action) => {
      state.reportData = {
        status: "idle",
        data: action.payload,
        error: {},
      }
    },
    [fetchAll.rejected.type]:(state, action) => {
      state.reportData = {
        status: "idle",
        data: [],
        crops: [],
        error: "unauthorized",
      }
    },
  }
})

export default harvestAllReportSlice.reducer
